import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useQueryParam = (param: string): string | null => {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    const value = params.get(param);
    return value ? decodeURIComponent(value) : null;
  }, [location.search, param]);
};

export const useRemoveAllUrlParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    const newUrl = location.pathname;
    navigate(newUrl, { replace: true });
  };
};

export const getUrlWithoutParams = (): string => {
  return `${window.location.origin}${window.location.pathname}`;
};

export const getUrlWithoutHost = (): string => {
  return (
    window.location.pathname + window.location.search + window.location.hash
  );
};
